module.exports = __webpack_public_path__ + "static/media/logo.a7ccfa45.svg";